import { defaultLocale } from './default-locale';

export const locales: string[] = [
  // `en` (the default) is registered via defaultLocale and has no URL prefix.
  defaultLocale,
  // Australian English — British/Australian spelling. Uses the BCP-47 tag
  // `en-AU` (not bare `au`, which is a country code, not a language) so
  // `<html lang>`, Intl.* and Accept-Language detection resolve correctly.
  // Message files live in apps/web/i18n/messages/en-AU/.
  'en-AU',
  // Spanish — message files live in apps/web/i18n/messages/es/.
  'es',
  // 'fr', // French
];
